const { default: gql } = require('graphql-tag')

export const disableUserAdminAccessMutation = gql`
  mutation DisableUserAdminAccess($userId: ID!) {
    disableUserAdminAccess(userId: $userId) {
      id
    }
  }
`
